// if negative dpr, it'll negate it and use it always
// if positive dpr, it'll use it if no window present, otherwise it will use window.devicePixelRatio
export default function imgixSource (src, width, height, fit = 'crop', dpr = 1, crop = 'faces') {
  const finalDpr = dpr < 0 ? -dpr : (typeof window !== 'undefined' ? window.devicePixelRatio || dpr : dpr) || 1

  if (src.indexOf('data:image/') === 0) {
    return src
  }

  if (!src || src.indexOf('https://www.apprentus.com/assets/design/default_avatar.png') === 0) {
    return 'https://www.apprentus.com/assets/design/default_avatar.png'
  }

  return `${src}?ch=Width,DPR&fit=${fit}&crop=${crop}&auto=format,compress&w=${width}&h=${height ||
    width}&dpr=${finalDpr}&frame=1`
}
